module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp3_8023.ef78ed7c.png";